package com.merkost.handpass.sharedweb.components

import androidx.compose.runtime.Composable
import com.merkost.handpass.sharedweb.theme.HandpassColors
import com.merkost.handpass.sharedweb.theme.HandpassSpacing
import com.merkost.handpass.sharedweb.theme.HandpassTypography
import com.merkost.handpass.sharedweb.theme.WebIconSize
import com.merkost.handpass.sharedweb.theme.WebIconStroke
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun WebImageUnavailable(
    label: String = "Image unavailable",
    iconSize: Int = WebIconSize.P30,
    showLabel: Boolean = true,
    onInk: Boolean = false,
) {
    val foreground = if (onInk) HandpassColors.OnInk else HandpassColors.TextMuted
    Div({
        classes("hp-image-unavailable")
        attr("role", "img")
        attr("aria-label", label)
        style {
            property("position", "absolute")
            property("inset", "0")
            property("box-sizing", "border-box")
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            gap(HandpassSpacing.XS)
            padding(HandpassSpacing.SM)
            property("text-align", "center")
            property("color", foreground)
            property("pointer-events", "none")
        }
    }) {
        Icon(
            icon = WebIcon.Camera,
            size = iconSize,
            color = foreground,
            strokeWidth = WebIconStroke.Thin,
        )
        if (showLabel) {
            Span({
                style {
                    fontSize(HandpassTypography.XS)
                    property("font-weight", "600")
                    property("line-height", "1.2")
                    property("letter-spacing", "0")
                    property("max-width", "100%")
                }
            }) { Text(label) }
        }
    }
}
